module.exports = __webpack_public_path__ + "img/dku.02189.66dc93d6.png";